import { render } from "./LoginModelNew.vue?vue&type=template&id=6894546a&scoped=true"
import script from "./LoginModelNew.vue?vue&type=script&lang=js"
export * from "./LoginModelNew.vue?vue&type=script&lang=js"

import "./LoginModelNew.vue?vue&type=style&index=0&id=6894546a&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1214705102/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6894546a"]])

export default __exports__